import PageButton from "@/components/PageEditor/editor-components/page-specific/custom/Button";
import PageButtonContainer from "@/components/PageEditor/editor-components/page-specific/custom/ButtonContainer";
import PageContentContainer from "@/components/PageEditor/editor-components/page-specific/custom/Content/components/Container";
import Grid from "@/components/PageEditor/editor-components/page-specific/custom/Grid/Grid";
import PageHeading from "@/components/PageEditor/editor-components/page-specific/custom/Heading";
import PageParagraph from "@/components/PageEditor/editor-components/page-specific/custom/Paragraph";
import HomeButton from "@/components/PageEditor/editor-components/page-specific/home/Content/components/HomeButton";
import HomeParagraph from "@/components/PageEditor/editor-components/page-specific/home/Content/components/HomeParagraph";
import StepButton from "@/components/PageEditor/editor-components/page-specific/steps/Content/components/Button";
import StepButtonContainer from "@/components/PageEditor/editor-components/page-specific/steps/Content/components/ButtonContainer";
import FilterContainer from "@/components/PageEditor/editor-components/page-specific/steps/Content/components/FilterContainer";
import StepParagraph from "@/components/PageEditor/editor-components/page-specific/steps/Content/components/Paragraph";
import StepTextContainer from "@/components/PageEditor/editor-components/page-specific/steps/Content/components/TextContainer";
import Div from "@/components/PageEditor/editor-components/shared/Div";
import Media from "@/components/PageEditor/editor-components/shared/Media";
import TableBlock from "@/components/PageEditor/editor-components/shared/TableBlock/TableBlock";
import { PageType } from "@/services/shared-models";
import { Element, ROOT_NODE, useEditor } from "@craftjs/core";
import { Box, Divider, IconButton, Tooltip } from "@mui/material";

const Toolbox = () => {
    const {
        connectors: { create },
    } = useEditor();

    const { pageType } = useEditor((state) => ({
        pageType: state.nodes[ROOT_NODE]?.data.props.pageType as PageType,
    }));

    const renderToolbox = () => {
        switch (pageType) {
            case PageType.Home:
                return (
                    <div className="flex flex-1 flex-col items-center">
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={HomeParagraph} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Paragraph" placement="right">
                                <IconButton disableRipple>P</IconButton>
                            </Tooltip>
                        </Box>
                        <Divider sx={{ width: "100%" }} />
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={HomeButton} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Button" placement="right">
                                <IconButton disableRipple>Btn</IconButton>
                            </Tooltip>
                        </Box>
                    </div>
                );

            case PageType.Step1:
            case PageType.Step2:
            case PageType.Step3:
                return (
                    <div className="flex flex-1 flex-col items-center">
                        <Box
                            ref={(ref: HTMLElement) => create(ref, <Element is={StepButtonContainer} canvas />)}
                            sx={{ m: 0.5 }}
                        >
                            <Tooltip title="Button Container" placement="right">
                                <IconButton disableRipple>BC</IconButton>
                            </Tooltip>
                        </Box>
                        <Box
                            ref={(ref: HTMLElement) => create(ref, <Element is={StepTextContainer} canvas />)}
                            sx={{ m: 0.5 }}
                        >
                            <Tooltip title="Text Container" placement="right">
                                <IconButton disableRipple>TC</IconButton>
                            </Tooltip>
                        </Box>
                        <Box
                            ref={(ref: HTMLElement) => create(ref, <Element is={FilterContainer} canvas />)}
                            sx={{ m: 0.5 }}
                        >
                            <Tooltip title="Filter Container" placement="right">
                                <IconButton disableRipple>FC</IconButton>
                            </Tooltip>
                        </Box>
                        <Divider sx={{ width: "100%" }} />
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={StepParagraph} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Paragraph" placement="right">
                                <IconButton disableRipple>P</IconButton>
                            </Tooltip>
                        </Box>
                        <Divider sx={{ width: "100%" }} />
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={StepButton} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Button" placement="right">
                                <IconButton disableRipple>Btn</IconButton>
                            </Tooltip>
                        </Box>
                    </div>
                );

            case PageType.Content:
                return (
                    <div className="flex flex-1 flex-col items-center">
                        <Box
                            ref={(ref: HTMLElement) => create(ref, <Element is={PageContentContainer} canvas />)}
                            sx={{ m: 0.5 }}
                        >
                            <Tooltip title="Section - Group of related content with an optional tag" placement="right">
                                <IconButton disableRipple>sect</IconButton>
                            </Tooltip>
                        </Box>
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={Div} canvas />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Div - Advanced CSS styled container" placement="right">
                                <IconButton disableRipple>div</IconButton>
                            </Tooltip>
                        </Box>
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={Grid} canvas />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Grid - Column-based container" placement="right">
                                <IconButton disableRipple>grid</IconButton>
                            </Tooltip>
                        </Box>
                        <Box
                            ref={(ref: HTMLElement) => create(ref, <Element is={PageButtonContainer} canvas />)}
                            sx={{ m: 0.5 }}
                        >
                            <Tooltip title="Container - Special container for buttons" placement="right">
                                <IconButton disableRipple>BC</IconButton>
                            </Tooltip>
                        </Box>
                        <Divider sx={{ width: "100%" }} />
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={PageHeading} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Heading" placement="right">
                                <IconButton disableRipple>H</IconButton>
                            </Tooltip>
                        </Box>
                        <Divider sx={{ width: "100%" }} />
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={PageParagraph} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Paragraph" placement="right">
                                <IconButton disableRipple>P</IconButton>
                            </Tooltip>
                        </Box>
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={PageButton} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Button" placement="right">
                                <IconButton disableRipple>btn</IconButton>
                            </Tooltip>
                        </Box>
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={Media} />)} sx={{ m: 0.5 }}>
                            <Tooltip
                                title="Media - An embedded image or video (or link to an external one)"
                                placement="right"
                            >
                                <IconButton disableRipple>Media</IconButton>
                            </Tooltip>
                        </Box>
                        <Box ref={(ref: HTMLElement) => create(ref, <Element is={TableBlock} />)} sx={{ m: 0.5 }}>
                            <Tooltip title="Table" placement="right">
                                <IconButton disableRipple>Tbl</IconButton>
                            </Tooltip>
                        </Box>
                    </div>
                );

            default:
                return null;
        }
    };

    return <div className="flex flex-col w-12 h-full opacity-100 bg-white">{renderToolbox()}</div>;
};

export default Toolbox;
